import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_URI, config } from 'app/app.config';

@Injectable()
export class SecureFileService {
    errors: any[] = [];

    baseUrl= BASE_URI.URL;

    constructor(private http: HttpClient) { }

    secureFileDownLoad(url: string) {
        return this.http.get(url, { responseType: 'blob' });
    };

    secureReadfile(url: string){
      return this.http.get(url, { responseType: 'blob' })
    }

}
